import src from "IMAGE";
export default { src, width: 34, height: 34, blurWidth: 0, blurHeight: 0};
